import React from "react";
import { Error401 } from "containers/Error/Error401";
const Error401Page = () => {
  return (
    <>
      <Error401 />
    </>
  );
};

export default Error401Page;
